import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast, Toaster } from "sonner";
import { ArrowRight, ArrowLeft, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { user, checked, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@cafe.com");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (checked && user) nav("/admin", { replace: true });
  }, [checked, user, nav]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) {
      toast.success("Signed in");
      nav("/admin", { replace: true });
    } else {
      toast.error(res.error || "Login failed");
    }
  };

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Toaster position="top-center" richColors />
      <div className="max-w-7xl w-full mx-auto px-6 lg:px-12 py-6">
        <Link to="/" data-testid="back-to-home" className="inline-flex items-center gap-2 text-sm text-muted-foreground link-underline">
          <ArrowLeft className="w-3.5 h-3.5" /> Back to event
        </Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-6">
        <div className="w-full max-w-md border border-border bg-card p-10">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 border border-foreground/70 flex items-center justify-center">
              <Lock className="w-4 h-4" strokeWidth={1.4} />
            </div>
            <div>
              <p className="label-eyebrow">okay room</p>
              <p className="font-display text-2xl leading-none mt-1">Staff sign in</p>
            </div>
          </div>

          <form onSubmit={onSubmit} className="mt-10 space-y-6" data-testid="admin-login-form">
            <label className="block">
              <span className="label-eyebrow">Email</span>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-email-input"
                className="mt-2 w-full bg-transparent border-b border-border py-2 focus:border-foreground focus:outline-none"
              />
            </label>
            <label className="block">
              <span className="label-eyebrow">Password</span>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-password-input"
                className="mt-2 w-full bg-transparent border-b border-border py-2 focus:border-foreground focus:outline-none"
              />
            </label>
            <button
              type="submit"
              disabled={submitting}
              data-testid="admin-login-submit-btn"
              className="group w-full inline-flex items-center justify-between px-5 py-4 bg-foreground text-background hover:bg-[hsl(var(--primary))] transition-colors disabled:opacity-60"
            >
              <span className="text-sm tracking-widest uppercase font-semibold">
                {submitting ? "Signing in..." : "Sign in"}
              </span>
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" strokeWidth={1.5} />
            </button>
          </form>

        </div>
      </div>
    </div>
  );
}
